import { useEffect, useState } from "react";

import { getWebApp } from "../lib/telegram.js";
import type { TelegramWebApp } from "../lib/telegram-types.js";

/**
 * Hook returning the Telegram WebApp instance. Returns null when not
 * running inside Telegram (e.g. during local browser dev).
 *
 * The instance itself is stable — Telegram swaps internal fields but
 * the reference stays put. Re-renders happen via the dedicated theme /
 * viewport hooks.
 */
export function useTelegramWebApp(): TelegramWebApp | null {
  const [wa] = useState<TelegramWebApp | null>(() => getWebApp());
  return wa;
}

/**
 * Subscribe to a single Telegram WebApp event. Cleans up on unmount.
 */
export function useWebAppEvent(
  event: string,
  handler: (...args: unknown[]) => void,
): void {
  const wa = useTelegramWebApp();
  useEffect(() => {
    if (!wa) return;
    wa.onEvent(event, handler);
    return () => {
      wa.offEvent(event, handler);
    };
  }, [wa, event, handler]);
}
